import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    issueDetailWrapper: {
        display: "flex",
        minHeight: "calc(100vh - 64px)",
    },
    leftContainer: {
        display: "flex",
        flexDirection: "column",
        flex: "75% 0 0",
    },
    rightContainer: {
        flex: "25% 0 0",
        backgroundColor: theme.palette.primary.main,
        boxShadow: `0px 2px 9px 0px ${theme.palette.dropShadows.main}`,
        padding: `${theme.spacing(11.25)} ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)}`,
    },
    backButton: {
        "&.MuiButtonBase-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 400,
            fontSize: "12px",
            color: theme.palette.text.primary,
            padding: 0,
            textTransform: "uppercase",
        },
        "&.MuiButtonBase-root .MuiSvgIcon-root": {
            fontSize: "12px",
        },
    },
    rcaDetailWrapperNoData: {
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
        fontFamily: "Source Sans 3",
        fontWeight: 700,
        color: theme.palette.primary.dark,
        gap: theme.spacing(2),
    },
    noDataIcon: {
        color: theme.palette.primary.dark,
    },
    ticketNumber: {
        marginTop: "14px",
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: theme.spacing(3),
        width: "100%",
        gap: theme.spacing(24),
    },
    headerMainInfo: {
        display: "flex",
        gap: theme.spacing(24),
        flex: "1 0 0",
    },
    headerActions: {
        display: "flex",
        marginLeft: "auto",
    },
    contentFormLabelBig: {
        fontFamily: "Source Sans 3",
        fontSize: "24px",
    },
    threeDotsMenuButton: {
        "&.MuiButtonBase-root": {
            padding: 0,
            minWidth: "auto",
            width: theme.spacing(10),
            height: theme.spacing(10),
            background: theme.palette.border.select,
            color: theme.palette.menu.icons.main,
            border: "none",
            "&:hover": {
                background: theme.palette.border.select,
                border: "none",
            },
        },
        "&.MuiButtonBase-root .MuiSvgIcon-root": {
            fontSize: "24px",
        },
    },
    divider: {
        marginTop: "16px !important",
        marginBottom: "16px !important",
    },
    rcaDetails: {
        marginTop: theme.spacing(2),
        display: "grid",
        gap: theme.spacing(4),
        gridTemplateColumns: "repeat(4, 1fr)",
        marginBottom: theme.spacing(4),
    },
    rcaDetailsSingleLine: {
        marginTop: theme.spacing(4),
        display: "flex",
        width: "100%",
    },
    card: {
        marginTop: "24px !important",
    },
    cardContent: {
        padding: "16px !important",
    },
    cardContentFishboneDiagram: {
        padding: "40px !important",
    },
    cardContentObservations: {
        maxHeight: "300px",
        overflowY: "auto",
        padding: "16px !important",
    },
    progressWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(4),
        fontFamily: "Source Sans 3",
        fontSize: "14px",
        color: theme.palette.info.main,
    },
    documentFilesWrapper: {
        marginTop: theme.spacing(10),
        marginBottom: theme.spacing(10),
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
        gap: theme.spacing(12),
    },
    documentFileWrapper: {
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
        fontFamily: "Source Sans 3",
        fontSize: "14px",
    },
    iconWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 48,
        height: 48,
        borderRadius: "100%",
        backgroundColor: theme.palette.secondary.main,
    },
    icon: {
        color: theme.palette.info.light,
    },
    mediaFilesWrapper: {
        marginTop: "15px",
        marginBottom: "15px",
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: theme.spacing(7.5, 10),
    },
    mediaFile: {
        objectFit: "cover",
        width: "100%",
        height: "306px",
    },
    mediaLegend: {
        margin: 0,
        fontSize: "12.5px",
        fontFamily: "Source Sans 3",
        color: theme.palette.primary.darker,
    },
    mediaLink: {
        textDecoration: "none",
    },
    tableCellCustomStyle: {
        padding: "16px 8px !important",
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(8),
    },
    datePicker: {
        width: "100%",
    },
    formItemDivider: {
        width: "100%",
    },
    labelWithAction: {
        display: "flex !important",
        alignItems: "center",
        justifyContent: "space-between",
    },
    labelButton: {
        "&.MuiButtonBase-root": {
            padding: 0,
            minWidth: "auto",
        },
    },
    rcaMembersWrapper: {
        marginTop: theme.spacing(3),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    rcaMembersItemWrapper: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    mediaFilesFiveWhyAnalysisWrapper: {
        display: "flex",
        marginTop: theme.spacing(4),
        justifyContent: "center",
        alignItems: "center",
    },
    fiveWhyAnalysisDocumentFilesWrapper: {
        marginTop: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(2),
    },
    disabledDropdown: {
        "& div": {
            WebkitTextFillColor: "unset !important",
        },
        "&.Mui-disabled .MuiSelect-icon": {
            display: "none",
        },
    },
    inlineFormDatePicker: {
        width: "100%",
        "& .MuiOutlinedInput-root": {
            height: 41,
        },
    },
    inlineFormRow: {
        display: "flex",
        alignItems: "flex-end",
        gap: theme.spacing(4),
        width: "100%",
    },
    inlineFormField: {
        flex: 1,
        minWidth: 0,
    },
}));
